import mitt from 'mitt'

/* eslint-disable no-underscore-dangle */
export const DEFAULT_INTERVAL = 5e3

// Set the name of the hidden property and the change event for visibility
let hidden
let visibilityChange
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}

function pageIsVisible() {
  if (typeof document[hidden] === 'undefined' || !document[hidden]) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const handler = () => {
      document.removeEventListener(visibilityChange, handler, false)
      resolve()
    }

    document.addEventListener(visibilityChange, handler, false)
  })
}

function noop() {

}

export class Poller {
  constructor(fn, interval = DEFAULT_INTERVAL, ...args) {
    this.fn = (...fnArgs) => fn(...fnArgs)
    this._interval = interval
    this._args = args || []
    this.emitter = mitt()
    this.timer = null
    this.request = null
  }

  /**
   * Get or set interval
   * @param {Number} interval
   * @return {any}
   */
  interval(interval) {
    if (typeof interval !== 'undefined') {
      this._interval = interval
    }
    return this._interval
  }

  /**
   * Get or set args fn should be called with
   * @param {any} args
   * @return {any}
   */
  args(...args) {
    if (args.length) {
      this._args = args
    }
    return this._args
  }

  async fetch(...args) {
    this.stopped = false

    if (args) {
      this.args(...args)
    }

    if (this.timer) {
      clearTimeout(this.timer)
    }

    const poll = async (resolve, reject, forceNewRequest = true) => {
      await pageIsVisible()
      try {
        let currentRequest = this.request
        if (forceNewRequest || !this.request) {
          currentRequest = this.fn(...this.args())
          this.request = currentRequest
        }
        this.emitter.emit('request')
        const response = await this.request
        if (currentRequest === this.request) {
          resolve(response)
          this.emitter.emit('response', response)
          this.request = null
        }

        if (!this.stopped) {
          this.timer = setTimeout(poll, this._interval, noop, noop, false)
        }
      } catch (e) {
        this.emitter.emit('error', e)
      }
    }

    return new Promise(poll)
  }

  on(...args) {
    this.emitter.on(...args)
    return this
  }

  off(...args) {
    this.emitter.off(...args)
    return this
  }

  poll(callback, interval) {
    this.fn = callback
    this.interval(interval)

    return this
  }

  pause() {
    this.stopped = true
    clearTimeout(this.timer)
  }

  resume(...args) {
    this.fetch(...args)
  }

  stop() {
    this.stopped = true
    this.emitter.all.clear()
    clearTimeout(this.timer)
  }
}
